import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';

import {
  generateCustomIndexFn,
  RouteTabGroupComponent,
  TabGroupConfig,
} from '@features/tab-group/route-tab-group.component';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, RouteTabGroupComponent],
  selector: 'aux-protocol-entry',
  templateUrl: './protocol-entry.component.html',
})
export class ProtocolEntryComponent {
  private readonly launchDarklyService = inject(LaunchDarklyService);

  indexFn = generateCustomIndexFn(
    `${ROUTING_PATH.INVESTIGATOR.INDEX}/${ROUTING_PATH.INVESTIGATOR.PROTOCOL_ENTRY.INDEX}`
  );
  tabs: TabGroupConfig[] = [
    {
      label: 'Protocol Entry',
      route: `/${ROUTING_PATH.INVESTIGATOR.INDEX}/${ROUTING_PATH.INVESTIGATOR.PROTOCOL_ENTRY.INDEX}`,
      show: toObservable(this.launchDarklyService.$select((flags) => flags.tab_protocol_entry)),
    },
    {
      label: 'Patient Groups',
      route: ROUTING_PATH.INVESTIGATOR.PROTOCOL_ENTRY.PATIENT_GROUPS,
      show: toObservable(this.launchDarklyService.$select((flags) => flags.tab_patient_groups)),
    },
  ];
}
